






































































































































































































































































































































































































































































































































































import { localISODate } from "@/utils/localDate";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import Store from "@/store/modules/MonitoringHarianNicuStore";
import Service from "@/services/MonitoringHarianNicuService";
import TandaVitalSvc from "@/services/TandaVital";
import {
  NICU_OBS_FIELDS,
  NicuAlertItem,
  NicuShiftTotals,
  PERABAAN_NADI_OPTIONS,
  RESPIRASI_SCORE_OPTIONS,
  WARNA_KULIT_OPTIONS,
  TONUS_OPTIONS,
  AKTIVITAS_OPTIONS,
  KESADARAN_OPTIONS,
  POSISI_OPTIONS,
  HISAP_LENDIR_OPTIONS,
  BAB_OPTIONS,
  WARNA_CAIRAN_OPTIONS,
  CARA_FEEDING_OPTIONS,
  MODE_VENTILASI_OPTIONS,
  optItems,
  optLegend,
  downRrScore,
  downScore
} from "@/types/monitoring_harian_nicu";
import moment from "moment";

@Component({
  inject: {
    isReadOnly: { default: () => () => false },
    verifikasiTerkunciFn: {
      from: "isVerifikasiTerkunci",
      default: () => () => false
    }
  }
})
export default class MonitoringHarianNicuPage extends Vue {
  @Prop({ required: true }) isActive!: boolean;
  isReadOnly!: () => boolean;
  verifikasiTerkunciFn!: () => boolean;

  get verifikasiTerkunci(): boolean {
    return this.verifikasiTerkunciFn();
  }

  selectedDate = "";
  savingObs = false;
  verifyingDpjp = false;
  deleting = false;
  obsDialog = false;
  saveTimeout: ReturnType<typeof setTimeout> | null = null;
  obsFields = NICU_OBS_FIELDS;
  asesmenFields = [
    { key: "a", label: "A" },
    { key: "b", label: "B" },
    { key: "c", label: "C" },
    { key: "d", label: "D" },
    { key: "e", label: "E" },
    { key: "ast_sp", label: "ASI/SF" }
  ];

  perabaanNadiItems = optItems(PERABAAN_NADI_OPTIONS);
  warnaKulitItems = optItems(WARNA_KULIT_OPTIONS);
  tonusItems = optItems(TONUS_OPTIONS);
  aktivitasItems = optItems(AKTIVITAS_OPTIONS);
  kesadaranItems = optItems(KESADARAN_OPTIONS);
  posisiItems = optItems(POSISI_OPTIONS);
  hisapLendirItems = optItems(HISAP_LENDIR_OPTIONS);
  caraFeedingItems = optItems(CARA_FEEDING_OPTIONS);
  modeVentilasiItems = optItems(MODE_VENTILASI_OPTIONS);
  respScoreItems = {
    retraksi: optItems(RESPIRASI_SCORE_OPTIONS.retraksi),
    sianosis: optItems(RESPIRASI_SCORE_OPTIONS.sianosis),
    jalan_masuk_udara: optItems(RESPIRASI_SCORE_OPTIONS.jalan_masuk_udara),
    grunting: optItems(RESPIRASI_SCORE_OPTIONS.grunting)
  };
  babCodes = BAB_OPTIONS.map(o => o.value);
  warnaCairanCodes = WARNA_CAIRAN_OPTIONS.map(o => o.value);

  ttvRows: any[] = [];
  ttvPick: number | null = null;

  form: any = this.emptyForm();
  obsForm: any = { jam: 1 };

  emptyForm() {
    return {
      hari_rawat_ke: null,
      umur_hari: null,
      umur_kehamilan: null,
      bb_lahir: null,
      bb_masuk: null,
      bb_sekarang: null,
      masalah_aktif: null,
      masalah_ibu: null,
      ibu_dirawat_di: null,
      paritas: null,
      asesmen: {},
      et_no: null,
      et_kedalaman: null,
      catatan_penting: null
    };
  }

  // Pre-seed semua key agar reaktif di Vue 2 (Vue.set tidak diperlukan).
  emptyDetail() {
    return {
      respirasi: { retraksi: "", sianosis: "", jalan_masuk_udara: "", grunting: "" },
      warna: "",
      tonus: "",
      aktivitas: "",
      kesadaran: "",
      posisi: "",
      hisap_lendir: "",
      udema: { ekstremitas: "", palpebra: "", genital: "" },
      perut: { distensi: "", konsistensi: "", tali_pusat_merah: "", bising_usus: "" },
      ventilasi: { mode: "", rr: "", fio2: "", pip_peep: "", ti_ie: "", flow: "", cek_et: "" },
      intermina: { a: "", b: "", c: "", d: "", e: "" },
      feeding: { asi_cara: "", sf_cara: "" },
      keluar: { residu: "", iwl: "", diuresis: "" },
      lab: {
        ph: "", pco2: "", po2: "", hco3: "", be: "",
        hb: "", al: "", ar: "", at: "", hct: "", it_ratio: "",
        na: "", k: "", cl: "", ca: "",
        gds: "", album: "", bill_tot: "", bill_indirek: "", crp: ""
      }
    };
  }

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  get registerId() {
    return this.$route.params.register || this.$route.params.noReg || this.$route.params.registerId;
  }

  get pasienRm() {
    return this.$route.params.rm || this.$route.params.pasienRm;
  }

  get loading() {
    return Store.loading;
  }

  get list() {
    return Store.list;
  }

  get current() {
    return Store.current;
  }

  get alerts(): NicuAlertItem[] {
    return Store.alerts;
  }

  get isDpjpVerified(): boolean {
    return this.current ? !!this.current.dpjp_signed_at : false;
  }

  get shiftTotals(): NicuShiftTotals | null {
    return this.current && this.current.shift_totals ? this.current.shift_totals : null;
  }

  get legendLines() {
    return [
      { title: "Perabaan Nadi", text: optLegend(PERABAAN_NADI_OPTIONS) },
      { title: "Warna Kulit", text: optLegend(WARNA_KULIT_OPTIONS) },
      { title: "Tonus", text: optLegend(TONUS_OPTIONS) },
      { title: "Aktifitas", text: optLegend(AKTIVITAS_OPTIONS) },
      { title: "Tingkat Kesadaran", text: optLegend(KESADARAN_OPTIONS) },
      { title: "Posisi", text: optLegend(POSISI_OPTIONS) },
      { title: "Hisap Lendir", text: optLegend(HISAP_LENDIR_OPTIONS) },
      { title: "BAB", text: optLegend(BAB_OPTIONS) },
      { title: "Warna Residu / Muntah / Hisap Lendir", text: optLegend(WARNA_CAIRAN_OPTIONS) },
      { title: "Cara Feeding", text: optLegend(CARA_FEEDING_OPTIONS) },
      { title: "Mode Ventilasi", text: optLegend(MODE_VENTILASI_OPTIONS) }
    ];
  }

  get downLegendLines() {
    const labels: { [key: string]: string } = {
      frekuensi_nafas: "Frekuensi Nafas (auto dari RR)",
      retraksi: "Retraksi",
      sianosis: "Sianosis",
      jalan_masuk_udara: "Jalan Masuk Udara",
      grunting: "Grunting"
    };
    return Object.keys(RESPIRASI_SCORE_OPTIONS).map(key => ({
      title: labels[key] || key,
      text: optLegend(RESPIRASI_SCORE_OPTIONS[key])
    }));
  }

  get ttvItems() {
    const date = this.selectedDate;
    return this.ttvRows
      .filter(r => r.waktu_periksa && String(r.waktu_periksa).slice(0, 10) === date)
      .sort((a, b) => String(a.waktu_periksa).localeCompare(String(b.waktu_periksa)))
      .map(r => ({ value: r.id, text: this.ttvLabel(r) }));
  }

  get dialogRrScore(): number | null {
    return downRrScore(this.obsForm.rr);
  }

  get dialogDownScore(): number | null {
    return downScore(this.obsForm.rr, this.obsForm.detail ? this.obsForm.detail.respirasi : null);
  }

  get dialogDownInfo(): string {
    const s = this.dialogDownScore;
    if (s === null) return "";
    if (s > 7) return "ancaman gagal napas";
    if (s >= 4) return "distres napas sedang";
    return "tanpa distres napas";
  }

  get downChipColor(): string {
    const s = this.dialogDownScore;
    if (s === null) return "grey lighten-3";
    if (s > 7) return "red lighten-4";
    if (s >= 4) return "amber lighten-4";
    return "green lighten-4";
  }

  @Watch("isActive")
  onActiveChange(val: boolean) {
    if (val && this.registerId) this.loadData();
  }

  @Watch("current")
  onCurrentChange(val: any) {
    if (val) {
      this.form = {
        hari_rawat_ke: val.hari_rawat_ke,
        umur_hari: val.umur_hari,
        umur_kehamilan: val.umur_kehamilan,
        bb_lahir: val.bb_lahir,
        bb_masuk: val.bb_masuk,
        bb_sekarang: val.bb_sekarang,
        masalah_aktif: val.masalah_aktif,
        masalah_ibu: val.masalah_ibu,
        ibu_dirawat_di: val.ibu_dirawat_di,
        paritas: val.paritas,
        asesmen: val.asesmen ? { ...val.asesmen } : {},
        et_no: val.et_no,
        et_kedalaman: val.et_kedalaman,
        catatan_penting: val.catatan_penting
      };
    }
  }

  mounted() {
    if (this.isActive && this.registerId) this.loadData();
  }

  async loadData() {
    await Store.fetchByRegister(this.registerId);
    if (this.list.length > 0) {
      this.selectedDate = this.list[this.list.length - 1].tanggal;
      await Store.fetchByDate({ registerId: this.registerId, tanggal: this.selectedDate });
    }
  }

  async onSelectDate(tanggal: string) {
    this.selectedDate = tanggal;
    await Store.fetchByDate({ registerId: this.registerId, tanggal });
  }

  async onCarryForward() {
    const today = localISODate();
    await Store.carryForward({
      registerId: this.registerId,
      data: { tanggal: today, pasien_rm: this.pasienRm }
    });
    await Store.fetchByRegister(this.registerId);
    this.selectedDate = today;
  }

  saveParent() {
    if (this.saveTimeout) clearTimeout(this.saveTimeout);
    this.saveTimeout = setTimeout(async () => {
      const current = this.current;
      if (!current) return;
      await Store.updateMonitoring({
        id: current.id,
        data: {
          register_id: this.registerId,
          pasien_rm: this.pasienRm,
          tanggal: current.tanggal,
          ...this.form
        }
      });
    }, 800);
  }

  obsByJam(jam: number): any {
    if (!this.current || !this.current.observasi) return null;
    return this.current.observasi.find(o => o.jam === jam) || null;
  }

  valOf(jam: number, key: string): any {
    const o = this.obsByJam(jam);
    return o ? (o as any)[key] : "";
  }

  rowClass(jam: number): string {
    const o = this.obsByJam(jam);
    if (!o || !o.alert_level || !o.alert_level.length) return "";
    return o.alert_level.some(a => a.level === "critical") ? "red lighten-5" : "amber lighten-5";
  }

  downScoreOf(jam: number): number | null {
    const o = this.obsByJam(jam);
    return o && o.down_score !== undefined ? o.down_score : null;
  }

  downRrScoreOf(jam: number): number | null {
    const o = this.obsByJam(jam);
    return o ? downRrScore(o.rr) : null;
  }

  downCellClass(score: number | null): string {
    if (score === null || score === undefined) return "";
    if (score > 7) return "red lighten-4";
    if (score >= 4) return "amber lighten-4";
    return "";
  }

  openObs(jam: number) {
    const existing = this.obsByJam(jam);
    const base: any = {
      jam,
      suhu: null,
      kelembapan_indikator: "",
      hr: null,
      td: "",
      perabaan_nadi: "",
      spo2: null,
      rr: null,
      tindakan: "",
      instruksi_dokter: "",
      obat: "",
      founding_asi: "",
      founding_sf: "",
      muntah: "",
      bab: "",
      cairan_keluar_bak: ""
    };
    const merged: any = existing ? { ...base, ...existing } : base;
    merged.jam = jam;
    merged.detail = this.mergeDetail(existing ? (existing as any).detail : null);
    this.obsForm = merged;
    this.ttvPick = null;
    this.fetchTtv();
    this.obsDialog = true;
  }

  mergeDetail(saved: any) {
    const base = this.emptyDetail();
    if (!saved) return base;
    return {
      respirasi: { ...base.respirasi, ...(saved.respirasi || {}) },
      warna: saved.warna != null ? saved.warna : "",
      tonus: saved.tonus != null ? saved.tonus : "",
      aktivitas: saved.aktivitas != null ? saved.aktivitas : "",
      kesadaran: saved.kesadaran != null ? saved.kesadaran : "",
      posisi: saved.posisi != null ? saved.posisi : "",
      hisap_lendir: saved.hisap_lendir != null ? saved.hisap_lendir : "",
      udema: { ...base.udema, ...(saved.udema || {}) },
      perut: { ...base.perut, ...(saved.perut || {}) },
      ventilasi: { ...base.ventilasi, ...(saved.ventilasi || {}) },
      intermina: { ...base.intermina, ...(saved.intermina || {}) },
      feeding: { ...base.feeding, ...(saved.feeding || {}) },
      keluar: { ...base.keluar, ...(saved.keluar || {}) },
      lab: { ...base.lab, ...(saved.lab || {}) }
    };
  }

  async fetchTtv() {
    try {
      const res: any = await TandaVitalSvc.getByRegister(this.registerId);
      const rows = res && res.data ? res.data : res;
      this.ttvRows = Array.isArray(rows) ? rows : [];
    } catch (e) {
      this.ttvRows = [];
    }
  }

  ttvLabel(r: any): string {
    const parts: string[] = [];
    if (r.suhu_badan !== null && r.suhu_badan !== undefined && r.suhu_badan !== "") parts.push(`S ${r.suhu_badan}`);
    if (r.frekuensi_nadi) parts.push(`HR ${r.frekuensi_nadi}`);
    if (r.frekuensi_nafas) parts.push(`RR ${r.frekuensi_nafas}`);
    if (r.saturasi_oksigen) parts.push(`SpO2 ${r.saturasi_oksigen}`);
    const tdText = r.tekanan_darah_text || (r.sistole && r.diastole ? `${r.sistole}/${r.diastole}` : "");
    if (tdText) parts.push(`TD ${tdText}`);
    return `${moment(r.waktu_periksa).format("HH:mm")} — ${parts.join(" · ") || "tanpa nilai"}`;
  }

  applyTtv(id: number | null) {
    if (id === null || id === undefined) return;
    const r = this.ttvRows.find(x => x.id === id);
    if (!r) return;
    if (r.suhu_badan !== null && r.suhu_badan !== undefined && r.suhu_badan !== "") this.obsForm.suhu = Number(r.suhu_badan);
    if (r.frekuensi_nadi !== null && r.frekuensi_nadi !== undefined) this.obsForm.hr = r.frekuensi_nadi;
    if (r.frekuensi_nafas !== null && r.frekuensi_nafas !== undefined) this.obsForm.rr = r.frekuensi_nafas;
    if (r.saturasi_oksigen !== null && r.saturasi_oksigen !== undefined) this.obsForm.spo2 = r.saturasi_oksigen;
    const tdText = r.tekanan_darah_text || (r.sistole && r.diastole ? `${r.sistole}/${r.diastole}` : "");
    if (tdText) this.obsForm.td = tdText;
  }

  detailOf(jam: number, group: string, key: string): any {
    const o: any = this.obsByJam(jam);
    if (!o || !o.detail || !o.detail[group]) return "";
    return o.detail[group][key] || "";
  }

  detailFlat(jam: number, key: string): any {
    const o: any = this.obsByJam(jam);
    if (!o || !o.detail) return "";
    return o.detail[key] || "";
  }

  get headerJk(): string {
    const sex = this.current && this.current.pasien ? (this.current.pasien.sex || "").toUpperCase() : "";
    if (sex === "L") return "Laki-laki";
    if (sex === "P") return "Perempuan";
    return sex;
  }

  get bbPct(): string {
    const lahir = this.form.bb_lahir;
    const now = this.form.bb_sekarang;
    if (!lahir || !now) return "";
    return (((now - lahir) / lahir) * 100).toFixed(1) + "%";
  }

  async saveObs() {
    if (!this.current) return;
    this.savingObs = true;
    try {
      await Service.storeObservasi(this.current.id, this.obsForm);
      await Store.fetchByDate({ registerId: this.registerId, tanggal: this.selectedDate });
      this.obsDialog = false;
    } finally {
      this.savingObs = false;
    }
  }

  async onVerifyDpjp() {
    if (!this.current || this.verifikasiTerkunci) return;
    if (!confirm("Verifikasi monitor harian NICU atas nama DPJP yang sedang login? Tindakan tercatat di audit trail.")) return;
    this.verifyingDpjp = true;
    try {
      await Store.verifyDpjp(this.current.id);
      await Store.fetchByRegister(this.registerId);
    } catch (e) {
      // handled by service
    } finally {
      this.verifyingDpjp = false;
    }
  }

  async onDelete() {
    if (!this.current || !confirm("Yakin ingin menghapus monitor hari ini?")) return;
    this.deleting = true;
    try {
      await Store.deleteMonitoring(this.current.id);
      await Store.fetchByRegister(this.registerId);
      if (this.list.length > 0) {
        this.selectedDate = this.list[this.list.length - 1].tanggal;
        await Store.fetchByDate({ registerId: this.registerId, tanggal: this.selectedDate });
      } else {
        this.selectedDate = "";
      }
    } finally {
      this.deleting = false;
    }
  }

  cetakPdf() {
    if (this.current) Service.printPdf(this.current.id);
  }

  formatDate(val: string): string {
    return val ? moment(val).format("DD-MM") : "";
  }

  formatFull(val: string): string {
    return val ? moment(val).format("DD-MM-YYYY") : "";
  }
}
